<script lang="ts">
  import { fade } from 'svelte/transition'
  import globalStore from '@/stores/global.svelte'
  import { isEmpty } from 'lodash'

  let {
    errors = [],
  } = $props()

  let globals = $derived(globalStore.errors)
  let hasErrors = $derived(!isEmpty(errors) || !isEmpty(globals))
</script>

{#if hasErrors}
  <div class="form-errors" transition:fade>
    <div class="form-errors__inner active" role="alert">
      <div class="form-errors__title">Please fix this:</div>
      <div class="form-errors__msg">
        {#each globals as err (err)}
          <div>{err}</div>
        {/each}
        {#each errors as err}
          <div>{err}</div>
        {/each}
      </div>
    </div>
  </div>
{/if}
